/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { availableGroupSchema } from "./availableGroupSchema.ts";

export const groupListPathOrgUnitIdSchema = z.uuid();

export const groupListStatus200Schema = z.array(availableGroupSchema);

export const groupListResponseSchema = groupListStatus200Schema;
